import { Injectable } from '@angular/core';

// Plugins
import { Device } from '@capacitor/device';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

// Abstracts
import { NgAnalyticsService } from '../abstracts';

@Injectable()
export class AnalyticsService implements NgAnalyticsService {

    public analyticsEnabled = false;

    public async initialize(): Promise<void> {
        const deviceInfo = await Device.getInfo();
        const platformAppId: string = this.createPlatformAppId(deviceInfo.platform);
        return FirebaseAnalytics.initializeFirebase({
            apiKey: 'AIzaSyCbLzDdfEEh26PG04YwC2Xdf_ZqtB1AEZw',
            authDomain: 'duensing-mitarbeiter-dev.firebaseapp.com',
            databaseURL: 'https://duensing-mitarbeiter-dev.firebaseio.com',
            projectId: 'duensing-mitarbeiter-dev',
            storageBucket: 'duensing-mitarbeiter-dev.appspot.com',
            messagingSenderId: '9128087425',
            appId: platformAppId,
            measurementId: 'G-FZPTDWK4HH'
        })
        .then(() => {
            this.analyticsEnabled = true;
        });
    }

    public async enable(): Promise<void> {
        // return FirebaseAnalytics.enable();
        return new Promise((resolve) => resolve());
    }

    public disable(): Promise<void> {
        // return FirebaseAnalytics.disable();
        return new Promise((resolve) => resolve());
    }

    public toggle(status: boolean): Promise<void> {
        // return status ? this.enable() : this.disable();
        return new Promise((resolve) => resolve());
    }

    public trackEvent(event: string, properties?: { [key: string]: string }): Promise<void> {
        // return FirebaseAnalytics.logEvent({ name: event, params: properties });
        return new Promise((resolve) => resolve());
    }

    public setScreenName(screenName: string, nameOverride?: string): Promise<any> {
        // return FirebaseAnalytics.setScreenName({ screenName, nameOverride });
        return new Promise((resolve) => resolve(''));
    }

    public setUserId(userId: number): Promise<any> {
        // return FirebaseAnalytics.setUserId({ userId: userId.toString() });
        return new Promise((resolve) => resolve(''));
    }

    public setUserProperty(properties: { name: string, value: string }): Promise<any> {
        // return FirebaseAnalytics.setUserProperty(properties);
        return new Promise((resolve) => resolve(''));
    }

    private createPlatformAppId(platform: string): string {
        return `1:9128087425:${platform}:50d116452d529c7daca280`;
    }

}
